import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { JungleMascot } from '@/components/core/ThemeMascot/mascots';

export const jungleTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.JUNGLE,
  hover: {
    transform: 'translateY(-8px) scale(1.02)',
    transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  click: {
    transform: 'scale(0.92)',
    transition: 'transform 0.12s ease-out',
  },
  idle: {
    animationName: 'playful-jungle-bounce',
    animationDuration: '2.5s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.08) rotate(-3deg)',
    transition: 'transform 0.2s ease-out',
  },
  particles: {
    enabled: true,
    count: 7,
    characters: ['🍃', '🌿', '🦜', '🌺'],
    spread: 55,
    duration: 1100,
    size: 16,
  },
  keyframes: [
    {
      name: 'playful-jungle-bounce',
      css: `@keyframes playful-jungle-bounce {
  0%, 100% { transform: translateY(0); }
  40% { transform: translateY(-4px); }
  60% { transform: translateY(-2px); }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/button_soft', volume: 0.15, rate: 0.8 },
    click: { name: 'arcade/jump', volume: 0.25 },
  },
  metadata: {
    label: 'Jungle',
    icon: IconName.LEAF,
    previewEmoji: '🌴',
    description: 'Bouncy wild energy',
    mascotEmoji: '🦜',
    mascotComponent: JungleMascot,
  },
};
